export default __webpack_public_path__ + "/dist/images/logo6.2af1c78029237e2088f21d7095623c4d.png";